module.exports = __webpack_public_path__ + "img/google-ar.d50b5a97.png";